import React from 'react';

//Components
import { IconedButton } from 'components/IconedButton';
import { useNavigate } from 'components/lib';

//Helpers
import { UnlimitedCard } from 'components/unlimitedCard/card';

export function Warning({ message }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="w-full flex items-center justify-between">
        <IconedButton
          size="130px"
          color="#d32425"
          textColor="white"
          icon="arrow-left"
          text="Go back"
          action={() => {
            navigate('/app/quote/app');
          }}
        />
      </div>
      <UnlimitedCard className="mb-14 w-1/2 mx-auto" id="14">
        <div className="text-center">{message}</div>
      </UnlimitedCard>
    </div>
  );
}

export default Warning;
